var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvcIcon8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3626 40.8763L22.2488 52.7625C22.7326 53.2463 23.5163 53.2463 24.0001 52.7625L26.5113 50.2513C26.9951 49.7675 26.9951 48.9838 26.5113 48.5L14.6263 36.6125C14.1426 36.1288 13.3588 36.1288 12.8751 36.6125L10.3626 39.1238C9.87882 39.6075 9.87882 40.3925 10.3626 40.8763Z",
    fill: "#38383D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6263 43.3875L26.5126 31.5013C26.9963 31.0175 26.9963 30.2338 26.5126 29.75L24.0013 27.2388C23.5176 26.755 22.7338 26.755 22.2501 27.2388L10.3626 39.1238C9.87882 39.6075 9.87882 40.3913 10.3626 40.875L12.8738 43.3863C13.3576 43.8713 14.1426 43.8713 14.6263 43.3875Z",
    fill: "#38383D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6373 40.8763L57.7511 52.7625C57.2673 53.2463 56.4836 53.2463 55.9998 52.7625L53.4886 50.2513C53.0048 49.7675 53.0048 48.9838 53.4886 48.5L65.3748 36.6138C65.8586 36.13 66.6423 36.13 67.1261 36.6138L69.6373 39.125C70.1211 39.6075 70.1211 40.3925 69.6373 40.8763Z",
    fill: "#38383D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3736 43.3875L53.4873 31.5013C53.0036 31.0175 53.0036 30.2338 53.4873 29.75L55.9986 27.2388C56.4823 26.755 57.2661 26.755 57.7498 27.2388L69.6361 39.125C70.1198 39.6088 70.1198 40.3925 69.6361 40.8763L67.1248 43.3875C66.6423 43.8713 65.8573 43.8713 65.3736 43.3875Z",
    fill: "#38383D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8126 13.125H43.3001C42.7089 13.125 42.1976 13.54 42.0764 14.1187L31.2714 65.745C31.1489 66.3275 31.5939 66.875 32.1889 66.875H36.7014C37.2926 66.875 37.8039 66.46 37.9251 65.8812L48.7301 14.255C48.8514 13.6725 48.4076 13.125 47.8126 13.125Z",
    fill: "#9AFF42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvcIcon8);
export default __webpack_public_path__ + "static/media/svc_icon8.06a3ec0f81d63030f4b5177e1f340892.svg";
export { ForwardRef as ReactComponent };